module.exports = __webpack_public_path__ + "img/p6-p3-text.b4817da1.png";